import { render } from "./LegalNotice.vue?vue&type=template&id=d15bab9a"
import script from "./LegalNotice.vue?vue&type=script&lang=js"
export * from "./LegalNotice.vue?vue&type=script&lang=js"

import "./LegalNotice.vue?vue&type=style&index=0&id=d15bab9a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__